import axios from 'axios';
import { map, find, compose, path, concat, uniqBy } from 'ramda';
import { isDefined } from './helpers';
// import { setDpi } from './imgix';
import { removeBg } from './removebg';
// import jimp from 'jimp';
import { getBlobDataFromImageURL } from './images2';
import { resize128Image } from 'utils/images-ts';

export const getPicturePaths = signedRequests => map(s => s.picturePath, signedRequests);

export const findFileForSignedRequest = (request, files) => {
  return find(f => f.name === request.fileName, files);
};

export const uploadImages = async (imageFiles, signedRequests, signal) => {
  console.log('===uploadImages===');
  // console.log('===uploadImages===', imageFiles, signedRequests);
  // const files = await Promise.all(ima§geFiles.map(setDpi));
  const files = imageFiles;
  const putRequests = [];

  for (const request of signedRequests) {
    const file = findFileForSignedRequest(request, files);
    if (file) {
      const { signedRequest } = request;

      const requestOptions = {
        headers: {
          'Content-Type': file.type,
        },
        signal,
      };
      putRequests.push({ signedRequest, file, requestOptions });
    }
  }
  console.log('signedRequests', signedRequests);

  const axiosPromises = map(r => axios.put(r.signedRequest, r.file, r.requestOptions), putRequests);

  return Promise.all(axiosPromises);
};

const findFileForRequest = (files, fileName) => find(f => f.path === fileName, files);

export const getImagesForSorter = (
  existing,
  s3RequestsData,
  files,
  { prioritizeNewAiImage, lastAiImproveAsMain, sortedImages } = {}
) => {
  // console.log('===getImagesForSorter===', existing, s3RequestsData, files);
  const newImagesImageSort = isDefined(s3RequestsData)
    ? compose(
        map(r => ({
          pictureUrl: r.pictureUrl,
          id: `${r.pictureUrl}`,
          imgSrc: isDefined(findFileForRequest(files, r.fileName))
            ? URL.createObjectURL(findFileForRequest(files, r.fileName))
            : '',
          isNew: true,
          isExisting: false,
          fileName: r.fileName, // to find the file when reorder
        })),
        path(['getS3SignRequest', 'requests'])
      )(s3RequestsData)
    : [];

  const existingImagesImageSort = map(i => {
    const url = new URL(i);
    const searchParams = new URLSearchParams(url.search);
    const thumbnailUrl = resize128Image(i);
    return {
      pictureUrl: i,
      isExisting: true,
      isNew: false,
      isApoteaImage: searchParams.get('APOTEA_IMAGE') === '1',
      imgSrc: thumbnailUrl,
      id: `${i}`,
    };
  })(existing);

  const allImages = concat(
    existingImagesImageSort,
    uniqBy(i => i.pictureUrl, newImagesImageSort)
  );

  let finalImages = allImages;

  // Try to revert the old order
  if (sortedImages?.length > 0) {
    const allImagesMap = new Map();
    // collect all images keys
    allImages.forEach(img => {
      if (img.fileName) {
        allImagesMap.set(`fileName:${img.fileName}`, img);
      }
      allImagesMap.set(`pictureUrl:${img.pictureUrl}`, img);
    });

    const orderedImages = [];
    const usedKeys = new Set();

    sortedImages.forEach(oldImg => {
      let foundImg = null;
      let key = null;

      // find the imported files: use [fileName]
      if (oldImg.fileName) {
        key = `fileName:${oldImg.fileName}`;
        foundImg = allImagesMap.get(key);
      }

      // find the saved images: use [pictureUrl]
      if (!foundImg && oldImg.pictureUrl) {
        key = `pictureUrl:${oldImg.pictureUrl}`;
        foundImg = allImagesMap.get(key);
      }

      if (foundImg && !usedKeys.has(key)) {
        orderedImages.push({
          ...foundImg,
          isApoteaImage: oldImg.isApoteaImage ?? foundImg.isApoteaImage,
        });
        usedKeys.add(key);
        if (foundImg.fileName) {
          usedKeys.add(`fileName:${foundImg.fileName}`);
        } else {
          usedKeys.add(`pictureUrl:${foundImg.pictureUrl}`);
        }
      }
    });

    allImages.forEach(img => {
      const fileNameKey = img.fileName ? `fileName:${img.fileName}` : null;
      const pictureUrlKey = `pictureUrl:${img.pictureUrl}`;

      if (!usedKeys.has(pictureUrlKey) && (!fileNameKey || !usedKeys.has(fileNameKey))) {
        orderedImages.push(img);
      }
    });

    finalImages = orderedImages;
  }

  if (lastAiImproveAsMain) {
    const lastAiImprovedImage = finalImages.findLast(i => i.pictureUrl.includes('_AIIMPROVED'));
    const newImagesRest = finalImages.filter(i => i.pictureUrl !== lastAiImprovedImage?.pictureUrl);

    if (lastAiImprovedImage) {
      return [lastAiImprovedImage, ...uniqBy(i => i.pictureUrl, newImagesRest)];
    }
  }

  if (prioritizeNewAiImage && !existingImagesImageSort.length) {
    const newFirstAiImage = finalImages.find(i => i.pictureUrl.includes('_AIGENERATED'));
    const newImagesRest = finalImages.filter(i => i.pictureUrl !== newFirstAiImage?.pictureUrl);

    if (newFirstAiImage) {
      return [newFirstAiImage, ...uniqBy(i => i.pictureUrl, newImagesRest)];
    }
  }

  // console.log('newImagesImageSort', newImagesImageSort);
  // console.log('existingImagesImageSort', existingImagesImageSort);
  // console.log('allImages', allImages);

  return finalImages;
};

// const fileToDataUrl = async (file) => {
//   return new Promise((res, rej) => {
//     const reader = new FileReader();

//     reader.onload = () => {
//       // convert image file to base64 string
//       res(reader.result);
//     };

//     if (file) {
//       reader.readAsDataURL(file);
//     }
//   });
// }

export const downloadImage = async url => {
  if (!url) {
    return undefined;
  }
  console.log(`Download image ${url}`);
  try {
    const response = await fetch(url);
    if (response.ok) {
      let buffer = await response.buffer();
      return buffer;
    }
    throw new Error(response.statusText);
  } catch (error) {
    console.error(`Image ${url} error:`, error.message);
  }
  return undefined;
};

export const getImageWithBGRemoved = async (imageFile, token, timeout, addWatermark, product, producer, signal) => {
  console.log('===getImageWithBGRemoved===', imageFile);
  const fileName = isDefined(imageFile.name) ? imageFile.name.split('.')[0] : '';
  // const form = new FormData();

  // const newImage = await setDpi(imageFile);

  // form.append('image_file', imageFile);
  // form.append('size', 'full');
  // form.append('crop', true);
  // form.append('scale', 'original');

  let returned_error_string = '';
  let file;

  // const base64 = result.base64img;

  try {
    // get zip file from remove.bg
    // const url = await fileToDataUrl(imageFile);
    // console.log('!!!!url', url);
    // const imageBuffer = await downloadImage(imageFile);
    // const image = await jimp.read(url);
    // const mime = image?.getMIME();
    // let f;
    // if (mime && mime !== jimp.MIME_PNG) {
    //   // const pngImageBuffer = await image.getBufferAsync(jimp.MIME_PNG);
    //   // const pngBlob = new Blob([pngImageBuffer]);
    //   // const pngFile = new File([pngBlob], imageFile.name, { type: 'image/png' });
    //   // f = await removeBg(pngFile, token);
    //   // console.log('!!!!imageFile', imageFile);
    //   // console.log('!!!!pngFile', pngFile);
    // } else {
    //   // f = await removeBg(imageFile, token);
    // }
    // const colorType = image.colorType();
    // console.log('!!!!colorType', colorType);

    // unzip to memory
    // const { color, alpha } = await unzip(f);
    // merge image and alpha
    // const data = await createMask(color, alpha);
    // const resultImage = await jimp.read(data);
    // resultImage.colorType()
    const f = await removeBg(imageFile, token, timeout, addWatermark, product, producer, signal);
    // console.log('!!!ff', f);
    // console.log('!!!ff', typeof f);
    let res;
    if (f) {
      const blob = new Blob([f]);
      if (blob) {
        res = new File([blob], `${fileName}AIGENERATED.png`, { type: 'image/png' });
      }
    }

    if (res) {
      file = res;
      file.path = `${fileName}AIGENERATED.png`;
      file.preview = URL.createObjectURL(res);
    }
    // file = await setDpi(res);
    // // if (res.type !== 'image/png') {
    // if (file) {
    //   file.path = `${fileName}AIGENERATED.png`;
    //   file.preview = URL.createObjectURL(res);
    // }
  } catch (error) {
    try {
      const decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
      const startIndex = decodedString.indexOf('{');
      const endIndex = decodedString.lastIndexOf('}');
      const json = JSON.parse(decodedString.slice(startIndex, endIndex + 1));
      returned_error_string = json.errors[0]['title'].split('.')[0];
    } catch {}
    if (!returned_error_string) {
      if (error.request) {
        // The request was made but no response was received
        returned_error_string = `Error Remove Background: ${error.message}`;
      } else {
        // Something happened in setting up the request that triggered an Error
        returned_error_string = `Errors Remove Background: ${error.message}`;
      }
    }
  }

  // console.log('!!!file', file);
  if (file) {
    return file;
  } else {
    return { error: returned_error_string, fileName };
  }
};

export const downloadImageAsFile = async (url, name, type, signal) => {
  const blob = await getBlobDataFromImageURL(url, signal);
  const file = new File([blob], name, { type });
  file.path = name;

  return file;
};
